import React from 'react';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Skeleton from '@mui/material/Skeleton';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useSnackbar } from 'notistack';
import TokenService from '../../services/TokenService';
import OrderListTable from './OrderListTable'

function CompletedOrders(props) {
    const [isFetching, setIsFetching] = React.useState(true);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [orders, setOrders] = React.useState([]);
    React.useEffect(() => {
        loadOrders(); // only called once
    }, []);

    function loadOrders() {
        setIsFetching(true);
        TokenService.post('', 'GetMyCompletedOrders')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);
                    let tempOrders = jsonData.Orders;

                    if (tempOrders != '') {
                        tempOrders = JSON.parse(tempOrders);
                    }

                    let userLevel = jsonData.ReturnerLevel;
                    if (userLevel != '') {
                        userLevel = JSON.parse(userLevel);
                    }
                    props.userLevelUpdated(userLevel);

                    setOrders(tempOrders);

                    setIsFetching(false);
                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    }

    function buildSkeleton() {
        return <div>
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
        </div>
    }

    function buildOrders() {
        if (orders.length == 0) {
            return <div>You have not completed any orders yet.</div>
        }
        else {
            return <OrderListTable Orders={orders} loggedInUser={props.loggedInUser} Section='Completed' />
        }
    }

    return (
        
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Card sx={{ minWidth: 300, maxWidth: 600, width: '100%', alignSelf: 'center', margin: '0px', padding:'0px' }}>
                <CardContent style={{pading:'5px'} }>
                    {(props.isFetching || isFetching) ? buildSkeleton() : buildOrders()}
                </CardContent>
            </Card>
        </div>
    );
}

export default CompletedOrders;